import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/antd/es/form/index.js
// module id = 1347
// module chunks = 0